/* eslint-disable prefer-template */
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// import "../../styles/landing/css/styles.scss";
import ReactGA from "react-ga";

import Aux from "../../hoc/_Aux/Aux";
// import Breadcrumb from "../components/Breadcrumb";

import MainVenues from "../map/MainVenues";

import NavLanding from "../../components/NavLanding";

import Text from "../../components/Text";

import logo from "../../styles/images/logo.png";
import iphoneMoc from "../../styles/images/landing/iPhone11.png";
import playStoreIcon from "../../styles/images/landing/playstore.png";
import appStoreIcon from "../../styles/images/landing/appstore.png";

import { Styles } from "./LandingStyles";
import siteAnalyticsService from "../../services/siteAnalyticsService";

ReactGA.initialize(process.env.REACT_APP_GA_ID_TRACKING);

function makeSessionId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

const ROTATING_WORDS = {
  eng: [
    "milongas",
    "eventos",
    "festivals",
    "marathons",
    "cities",
    "countries",
    "artists",
    "orchestras",
    "concerts",
  ],
  spa: [
    "milongas",
    "eventos",
    "festivales",
    "maratones",
    "ciudades",
    "países",
    "artistas",
    "orquestas",
    "conciertos",
  ],
};

const Landing = ({ lang }) => {
  const [wordIndex, setWordIndex] = useState(0);
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    ReactGA.pageview("landingPage" + window.location.search);
  });

  useEffect(() => {
    const sessionId = makeSessionId();
    const startTime = Date.now();

    // Fire immediately — geo is resolved server-side from the request IP
    siteAnalyticsService.track({ eventType: "page_view", sessionId });

    return () => {
      const duration = Math.round((Date.now() - startTime) / 1000);
      siteAnalyticsService.track({
        eventType: "page_leave",
        sessionId,
        duration,
      });
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setWordIndex((i) => (i + 1) % ROTATING_WORDS.eng.length);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const langId = lang?.language?.id || "eng";
  const words = ROTATING_WORDS[langId] || ROTATING_WORDS.eng;
  const searchFor = langId === "spa" ? "Buscar por" : "Search for";

  return (
    <Aux>
      {/* <Breadcrumb /> */}
      <Styles>
        <div className="wrapper">
          <div>
            {/* -- Navigation Section -- */}

            <NavLanding />

            {/* -- Header Section -- */}

            <div className="main" id="main">
              <div className="main" id="main">
                <div className="hero-section-landing landing-section-custom app-landing">
                  <div></div>
                  <div className="container">
                    <div className="hero-content-custom app-landing-content-custom">
                      <div className="row hero-content-landing">
                        <div className="col-12 header-text-landing">
                          <h1 style={{ fontFamily: `Montserrat` }}>
                            <Text tid="landingTitle" />
                          </h1>
                        </div>
                      </div>
                      <div
                        className="row align-items-start"
                        style={{
                          color: "#fff",
                        }}
                      >
                        <div className="col-12 col-md-7">
                          <p>
                            <Text tid="subTitleOne" />
                          </p>
                          <p
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              flexWrap: "wrap",
                            }}
                          >
                            <i
                              className="feather icon-check-circle"
                              style={{ fontSize: 18, flexShrink: 0 }}
                            />
                            <span>
                              <strong
                                style={{
                                  color: "#22c55e",
                                  fontSize: 17,
                                  fontWeight: 700,
                                }}
                              >
                                +1000
                              </strong>{" "}
                              <Text tid="subTitleTwo" />
                            </span>
                          </p>
                        </div>
                        <div className="col-12 col-md-5 mt-3 mt-md-0 search-for-block">
                          <p className="search-for-label">{searchFor}</p>
                          <p className="search-for-word">{words[wordIndex]}</p>
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div
                          className="col-12"
                          style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
                        >
                          <button
                            className="btn"
                            onClick={() => {
                              if (!showMap) {
                                siteAnalyticsService.track({ eventType: "map_toggle_click" });
                              }
                              setShowMap((m) => !m);
                            }}
                            style={{
                              background: "#fff",
                              color: "#4e6ac5",
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              border: "none",
                              padding: "10px 20px",
                              borderRadius: 8,
                              fontSize: 15,
                            }}
                          >
                            <i className="feather icon-map-pin" />
                            {showMap ? (
                              <Text tid="hideMilongasMap" />
                            ) : (
                              <Text tid="seeMilongasNearMe" />
                            )}
                          </button>
                          <button
                            className="btn"
                            onClick={() =>
                              document
                                .getElementById("downloadSection")
                                .scrollIntoView({ behavior: "smooth" })
                            }
                            style={{
                              background: "transparent",
                              color: "#fff",
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              border: "2px solid rgba(255,255,255,0.7)",
                              padding: "10px 20px",
                              borderRadius: 8,
                              fontSize: 15,
                            }}
                          >
                            <i className="feather icon-download" />
                            <Text tid="downloadAppBtn" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* -- Map Venue Section -- */}

                {showMap && (
                  <>
                    <div style={{ background: "#fff", padding: "20px 0 0" }}>
                      <div className="container">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 32,
                            flexWrap: "wrap",
                            paddingBottom: 16,
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              color: "#4e6ac5",
                              fontWeight: 600,
                            }}
                          >
                            <i className="feather icon-map-pin" />
                            <Text tid="statMilongasMapped" />
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              color: "#4e6ac5",
                              fontWeight: 600,
                            }}
                          >
                            <i className="feather icon-globe" />
                            <Text tid="statCountries" />
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              color: "#4e6ac5",
                              fontWeight: 600,
                            }}
                          >
                            <i className="feather icon-message-circle" />
                            <Text tid="statLanguages" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="counter-section">
                      <div className="container">
                        <MainVenues />
                      </div>
                    </div>
                    <div style={{ background: "#fff", height: 24 }} />
                  </>
                )}

                {/* -- How It Works Section -- */}

                <div
                  style={{
                    background: showMap
                      ? "linear-gradient(153.5deg, #54aa7c 0%, #4e6ac5 44.75%, #c870c8 100%)"
                      : "#f8f9fc",
                    paddingTop: 60,
                    paddingBottom: 60,
                    position: "relative",
                    zIndex: 1,
                    marginTop: showMap ? 0 : -60,
                    transition: "background 0.4s ease",
                  }}
                >
                  <div className="container">
                    <div style={{ marginBottom: 12 }}>
                      <span
                        style={{
                          background: "#eef0fb",
                          color: "#4e6ac5",
                          fontWeight: 700,
                          fontSize: 15,
                          letterSpacing: 1,
                          textTransform: "uppercase",
                          borderRadius: 50,
                          padding: "6px 18px",
                        }}
                      >
                        <Text tid="labelForDancers" />
                      </span>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        color: showMap ? "#fff" : "#999",
                        fontWeight: 500,
                        fontSize: 25,
                        textTransform: "uppercase",
                        letterSpacing: 2,
                        marginBottom: 40,
                      }}
                    >
                      <Text tid="howItWorksLabel" />
                    </p>
                    <div className="row text-center">
                      <div
                        className="col-12 col-md-4"
                        style={{
                          padding: "0 32px",
                          borderRight: showMap ? "1px solid rgba(255,255,255,0.25)" : "1px solid #e0e4f0",
                        }}
                      >
                        <i
                          className="feather icon-search"
                          style={{
                            fontSize: 36,
                            color: showMap ? "#fff" : "#4e6ac5",
                            marginBottom: 16,
                            display: "block",
                          }}
                        />
                        <h4
                          style={{
                            color: showMap ? "#fff" : "#4e6ac5",
                            fontFamily: "Montserrat",
                            fontWeight: 700,
                            marginBottom: 12,
                          }}
                        >
                          <Text tid="howItWorksSearch" />
                        </h4>
                        <p
                          style={{
                            color: showMap ? "rgba(255,255,255,0.85)" : "#666",
                            fontSize: 14,
                            lineHeight: 1.7,
                            margin: 0,
                          }}
                        >
                          <Text tid="howItWorksSearchText" />
                        </p>
                      </div>

                      <div
                        className="col-12 col-md-4"
                        style={{
                          padding: "0 32px",
                          borderRight: showMap ? "1px solid rgba(255,255,255,0.25)" : "1px solid #e0e4f0",
                        }}
                      >
                        <i
                          className="feather icon-sliders"
                          style={{
                            fontSize: 36,
                            color: showMap ? "#fff" : "#22c55e",
                            marginBottom: 16,
                            display: "block",
                          }}
                        />
                        <h4
                          style={{
                            color: showMap ? "#fff" : "#22c55e",
                            fontFamily: "Montserrat",
                            fontWeight: 700,
                            marginBottom: 12,
                          }}
                        >
                          <Text tid="howItWorksFilter" />
                        </h4>
                        <p
                          style={{
                            color: showMap ? "rgba(255,255,255,0.85)" : "#666",
                            fontSize: 14,
                            lineHeight: 1.7,
                            margin: 0,
                          }}
                        >
                          <Text tid="howItWorksFilterText" />
                        </p>
                      </div>

                      <div
                        className="col-12 col-md-4"
                        style={{ padding: "0 32px" }}
                      >
                        <i
                          className="feather icon-heart"
                          style={{
                            fontSize: 36,
                            color: showMap ? "#fff" : "#f97316",
                            marginBottom: 16,
                            display: "block",
                          }}
                        />
                        <h4
                          style={{
                            color: showMap ? "#fff" : "#f97316",
                            fontFamily: "Montserrat",
                            fontWeight: 700,
                            marginBottom: 12,
                          }}
                        >
                          <Text tid="howItWorksGoDance" />
                        </h4>
                        <p
                          style={{
                            color: showMap ? "rgba(255,255,255,0.85)" : "#666",
                            fontSize: 14,
                            lineHeight: 1.7,
                            margin: 0,
                          }}
                        >
                          <Text tid="howItWorksGoDanceText" />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* -- Organizer CTA Section -- */}

                <div style={{ background: "#fff", padding: "48px 0" }}>
                  <div className="container text-center">
                    <div style={{ marginBottom: 16, textAlign: "left" }}>
                      <span
                        style={{
                          background: "#ede9fe",
                          color: "#7c3aed",
                          fontWeight: 700,
                          fontSize: 15,
                          letterSpacing: 1,
                          textTransform: "uppercase",
                          borderRadius: 50,
                          padding: "6px 18px",
                        }}
                      >
                        <Text tid="labelForOrganizers" />
                      </span>
                    </div>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 12,
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          width: 64,
                          height: 64,
                          borderRadius: "50%",
                          background: "rgb(238, 240, 251)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <i
                          className="feather icon-star"
                          style={{ fontSize: 44, color: "rgb(78, 106, 197)" }}
                        />
                      </div>
                      <p
                        style={{
                          fontFamily: "Montserrat",
                          fontWeight: 600,
                          color: "#4e6ac5",
                          margin: 0,
                          fontSize: 25,
                          lineHeight: 1.2,
                        }}
                      >
                        <Text tid="organizerCtaTitle" />
                      </p>
                    </div>
                    <p
                      style={{
                        color: "#666",
                        fontSize: 16,
                        lineHeight: 1.7,
                        marginBottom: 20,
                      }}
                    >
                      <Text tid="organizerCtaSubtitle" />
                    </p>
                    <div style={{ display: "inline-block", textAlign: "left", marginBottom: 8 }}>
                    {["organizerCtaCheck1", "organizerCtaCheck2", "organizerCtaCheck3"].map((tid) => (
                      <div
                        key={tid}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 12,
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: "#22c55e",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <i className="feather icon-check" style={{ fontSize: 14, color: "#fff" }} />
                        </div>
                        <p style={{ margin: 0, color: "#333", fontSize: 15, lineHeight: 1.5 }}>
                          <Text tid={tid} />
                        </p>
                      </div>
                    ))}
                    </div>
                    <div style={{ marginBottom: 32 }} />
                    <Link
                      to="/request-access"
                      className="btn btn-primary"
                      style={{
                        padding: "14px 36px",
                        borderRadius: 8,
                        fontWeight: 600,
                        fontSize: 16,
                        display: "inline-block",
                      }}
                    >
                      <Text tid="organizerCtaButton" />
                    </Link>
                    <p
                      style={{
                        color: "#aaa",
                        fontSize: 13,
                        marginTop: 16,
                      }}
                    >
                      <i
                        className="feather icon-lock"
                        style={{ fontSize: 13, marginRight: 4 }}
                      />
                      <Text tid="organizerCtaNote" />
                    </p>
                  </div>
                </div>

                {/* -- Download Section -- */}

                <div id="downloadSection" className="download-section-landing">
                  <div className="container">
                    <div className="row align-items-flex-end">
                      {/* Phone mockup — overlaps into section below */}
                      <div
                        className="col-12 col-md-3 d-none d-md-block"
                        style={{
                          position: "relative",
                          zIndex: 2,
                          marginBottom: -50,
                          alignSelf: "flex-end",
                          paddingLeft: 0,
                        }}
                      >
                        <img
                          src={iphoneMoc}
                          alt="Bailo.app mobile"
                          style={{
                            maxHeight: 340,
                            width: "100%",
                            objectFit: "contain",
                            filter: "drop-shadow(0 12px 24px rgba(0,0,0,0.28))",
                          }}
                        />
                      </div>

                      {/* Download text + buttons */}
                      <div
                        className="col-12 col-md-5"
                        style={{
                          paddingLeft: 24,
                          paddingRight: 24,
                          paddingBottom: 32,
                        }}
                      >
                        <h2
                          style={{
                            fontFamily: "Montserrat",
                            fontWeight: 700,
                            color: "#fff",
                            marginBottom: 12,
                            fontSize: 25,
                          }}
                        >
                          <Text tid="downloadSectionTitle" />
                        </h2>
                        <p
                          style={{
                            color: "rgba(255,255,255,0.85)",
                            fontSize: 15,
                            marginBottom: 24,
                          }}
                        >
                          <Text tid="downloadSectionSubtitle" />
                        </p>
                        <div style={{ marginBottom: 24 }}>
                          {[
                            { icon: "feather icon-map-pin", tid: "downloadFeature1" },
                            { icon: "feather icon-bell", tid: "downloadFeature2" },
                            { icon: "feather icon-globe", tid: "downloadFeature3" },
                          ].map(({ icon, tid }) => (
                            <div
                              key={tid}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 12,
                                marginBottom: 12,
                              }}
                            >
                              <i
                                className={icon}
                                style={{ fontSize: 20, color: "#fff", flexShrink: 0, marginTop: 2 }}
                              />
                              <p
                                style={{
                                  margin: 0,
                                  color: "#fff",
                                  fontWeight: 700,
                                  fontSize: 15,
                                  lineHeight: 1.5,
                                }}
                              >
                                <Text tid={tid} />
                              </p>
                            </div>
                          ))}
                        </div>
                        <div
                          style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
                        >
                          <a
                            href="https://apps.apple.com/es/app/bailo-app/id1582308314?l=en"
                            target="_blank"
                            rel="noreferrer"
                            onClick={() =>
                              siteAnalyticsService.track({
                                eventType: "app_download_click",
                                platform: "ios",
                              })
                            }
                          >
                            <img
                              src={appStoreIcon}
                              alt="Download App Store"
                              style={{ height: 48 }}
                            />
                          </a>
                          <a
                            href="https://play.google.com/store/apps/details?id=com.bailoapp.bailoapp"
                            target="_blank"
                            rel="noreferrer"
                            onClick={() =>
                              siteAnalyticsService.track({
                                eventType: "app_download_click",
                                platform: "android",
                              })
                            }
                          >
                            <img
                              src={playStoreIcon}
                              alt="Download Play Store"
                              style={{ height: 48 }}
                            />
                          </a>
                        </div>
                      </div>

                      {/* WhatsApp card */}
                      <div
                        className="col-12 col-md-4"
                        style={{ paddingLeft: 16, paddingBottom: 32 }}
                      >
                        <div
                          style={{
                            background: "#fff",
                            borderRadius: 16,
                            padding: "28px 24px",
                            textAlign: "center",
                            boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                          }}
                        >
                          <div
                            style={{
                              width: 56,
                              height: 56,
                              borderRadius: "50%",
                              background: "#25d366",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 16px",
                            }}
                          >
                            <i
                              className="fa-brands fa-whatsapp"
                              style={{ fontSize: 28, color: "#fff" }}
                            />
                          </div>
                          <p
                            style={{
                              color: "#333",
                              fontSize: 14,
                              fontWeight: 600,
                              marginBottom: 16,
                              lineHeight: 1.5,
                            }}
                          >
                            <Text tid="whatsappContact" />
                          </p>
                          <a
                            href="https://chat.whatsapp.com/HPoSl8lt4EL2RkCyQ4up00"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              padding: "10px 24px",
                              borderRadius: 8,
                              border: "2px solid #25d366",
                              color: "#25d366",
                              fontWeight: 600,
                              fontSize: 14,
                              textDecoration: "none",
                            }}
                          >
                            <Text tid="SendMessage" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* -- FAQs Section -- */}

                <div className="client-section no-color">
                  <div className="container text-center no-color">
                    <div className="cta-sub text-center no-color">
                      <h1
                        className="wow fadeInUp"
                        data-wow-delay="0s"
                        style={{ fontFamily: `Montserrat`, fontSize: 25 }}
                      >
                        <Text tid="commonQuestions" />
                      </h1>
                      <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ color: "#666" }}>
                        <Text tid="commonQuestionsTextLanding" />
                        <br className="hidden-xs" />
                        <a
                          href="/knowledge-base"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Text tid="commonQuestions" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                {/* -- Footer Section -- */}

                <div className="footer">
                  <div className="container">
                    <div className="col-md-12 text-center">
                      <img src={logo} alt="Bailo.app" />
                      <ul className="footer-menu">
                        <li>
                          <a
                            href="https://www.linkedin.com/company/bailoapp"
                            target="_blank"
                            rel="noreferrer"
                          >
                            LinkedIn
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://twitter.com/BailoApp"
                            target="_blank"
                            rel="noreferrer"
                          >
                            X
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.youtube.com/channel/UC_Ps7_ryCvQ0DVO1NTY9ZIQ/about"
                            target="_blank"
                            rel="noreferrer"
                          >
                            YouTube
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.facebook.com/groups/bailoapp"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Facebook
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/bailo.app/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Instagram
                          </a>
                        </li>

                        <li>
                          <a
                            href="/privacy-policy"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Text tid="privacyPolicy" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="/terms-of-use"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Text tid="termsOfUse" />
                          </a>
                        </li>
                      </ul>
                      <div className="footer-text">
                        <p>
                          <Text tid="withLove" />
                        </p>
                      </div>
                      <div className="footer-text">
                        <p>Copyright © 2019 - 2026 All Rights Reserved.</p>
                        <p>🇦🇷🇩🇪</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Styles>
    </Aux>
  );
};

Landing.propTypes = {
  lang: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(Landing);
